"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/* eslint-disable valid-jsdoc */
/* eslint-disable guard-for-in */
/* eslint-disable no-empty */
/* eslint-disable no-empty-function */
/* eslint-disable no-unused-vars */
/* eslint-disable sort-imports */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaInfoImpl = void 0;
const parserCollection_1 = require("./parserCollection");
const internalDtmi_1 = require("./internalDtmi");
class SchemaInfoImpl {
    constructor(dtdlVersion, id, childOf, definedIn, entityKind) {
        this.parserClass = parserCollection_1.ParserCollection.SchemaInfoParser;
        this.dtdlVersion = dtdlVersion;
        this.id = id;
        this.childOf = childOf;
        this.definedIn = definedIn;
        this.entityKind = entityKind;
        this.description = {};
        this.displayName = {};
        this.supplementalTypeIds = [];
        this.supplementalProperties = {};
        this.supplementalTypes = [];
        this.isPartition = false;
        this.undefinedTypes = [];
        this.undefinedProperties = {};
        this._checkedForDescendantSchemaOrContentsComponentNarrow = false;
        this._idOfDescendantSchemaOrContentsComponentNarrow = undefined;
        this._checkedDescendantEnumValueDatatype = undefined;
        this._checkedForDescendantSchemaArray = false;
        this._idOfDescendantSchemaArray = undefined;
    }
    static initialize() {
        this._versionlessTypes = new Set().add("dtmi:dtdl:class:Entity").add("dtmi:dtdl:class:Schema");
    }
    addType(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dtmi, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    supplementalType) {
        throw new Error("Attempt to add type to non augmentable type SchemaInfo");
    }
    doesHaveType(typeId) {
        return SchemaInfoImpl._versionlessTypes.has(new internalDtmi_1.InDTMI(typeId).versionless);
    }
    doesPropertyDictContainKey(propertyName, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    key) {
        switch (propertyName) {
            default:
                return false;
        }
    }
    validateInstance(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instanceText) {
        throw new Error("cannot validate anything in an abstract class");
    }
    validateInstanceElement(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instanceElt) {
        throw new Error("cannot validate anything in an abstract class");
    }
    validateInstanceInternal(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instanceElt, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instanceName) {
        throw new Error("cannot validate anything in an abstract class");
    }
    validateInstanceV2(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instanceElt, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instanceName) {
        throw new Error("cannot validate anything in an abstract class");
    }
    validateInstanceV3(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instanceElt, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instanceName) {
        throw new Error("cannot validate anything in an abstract class");
    }
    /**
     * Set partition information.
     **/
    setPartitionInfo(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    partitionJsonText) {
        throw new Error(`attempt to set partition info on non-partition type SchemaInfoInfo`);
    }
    applyTransformationsV2(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    model, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parsingErrors) { }
    applyTransformationsV3(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    model, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parsingErrors) { }
    checkRestrictionsV2(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parsingErrors) { }
    checkRestrictionsV3(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parsingErrors) { }
    trySetObjectProperty(propertyName, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types
    value, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    key) {
        switch (propertyName) {
            default:
                break;
        }
        return false;
    }
    /**
     * Check the nesting depth of all descendant elementSchema or schema properties.
     **/
    checkDepthOfElementSchemaOrSchema(depth, depthLimit, tooDeepElementId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parsingErrors) {
        tooDeepElementId.ref = undefined;
        return true;
    }
    tryGetDescendantSchemaOrContentsComponentNarrow(elementId) {
        if (this._checkedForDescendantSchemaOrContentsComponentNarrow) {
            elementId.ref = this._idOfDescendantSchemaOrContentsComponentNarrow;
            return this._idOfDescendantSchemaOrContentsComponentNarrow !== undefined;
        }
        this._checkedForDescendantSchemaOrContentsComponentNarrow = true;
        elementId.ref = undefined;
        return false;
    }
    checkDescendantEnumValueDataType(ancestorId, datatype, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parsingErrors) {
        if (this._checkedDescendantEnumValueDatatype !== datatype) {
            this._checkedDescendantEnumValueDatatype = datatype;
        }
    }
    tryGetDescendantSchemaArray(elementId) {
        if (this._checkedForDescendantSchemaArray) {
            elementId.ref = this._idOfDescendantSchemaArray;
            return this._idOfDescendantSchemaArray !== undefined;
        }
        this._checkedForDescendantSchemaArray = true;
        elementId.ref = undefined;
        return false;
    }
    getCountOfExtendsNarrow(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parsingErrors) {
        throw new Error("Can not execute on an abstract class");
    }
    getCountOfContentsOrFieldsOrEnumValuesOrRequestOrResponseOrPropertiesOrSchemaOrElementSchemaOrMapValueNarrow(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parsingErrors) {
        throw new Error("Can not execute on an abstract class");
    }
}
exports.SchemaInfoImpl = SchemaInfoImpl;
//# sourceMappingURL=schemaInfoImpl.js.map